import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  icon?: React.ComponentProps<typeof Icon.Medium>['icon']
  placeholder: string
  value: unknown[]
}

function Placeholder({ icon, placeholder, value }: Props) {
  return (
    <Box flexDirection="row" width="full" flexWrap="noWrap" paddingLeft="s6" gap="s6">
      {icon && (
        <Box height="s24" width="s24" justifyContent="center" alignItems="center">
          <Icon.Medium icon={icon} color={value.length ? 'grey800' : 'grey400'} />
        </Box>
      )}
      <Box flexDirection="row" width="full" overflowX="hidden">
        <Text size="300" color={value.length ? 'grey1000' : 'grey600'} ellipsis>
          {placeholder}
        </Text>
      </Box>
    </Box>
  )
}

export default React.memo(Placeholder)
